module.exports = __webpack_public_path__ + "img/menu4.45eed597.png";